import React from 'react'
import styled from 'styled-components'
import { Flex } from 'rebass'
import { Form } from 'formik'

import Text from './Text'

import media from '../utils/style-utils'

export default ({children, ...others}) =>
  <Form {...others}>{children}</Form>

const Heading = styled(({...others}) =>
  <Text h3 fontSize={3} mb={3} mt={3} {...others} />
)`  
`

const Subheading = styled(({...others}) =>
  <Text h4 light fontSize={2} mb={3} mt={2} {...others} />
)`  
`

const Group = styled(({...others}) =>
  <Flex justifyContent='stretch' {...others} />
)`
  flex-direction: column;
  ${media.greaterThan('small')`
    flex-direction: row;
  `}
  
  & > * {         
    ${media.greaterThan('small')`
      flex: 1;
      margin-right: ${props => props.theme.space[2]}px;
    
      &:last-child {
        margin-right: 0;
      }
    `}
  }
`

export { Heading, Subheading, Group }


// WEBPACK FOOTER //
// ./src/components/Form.js